import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Cutlery = t0 => {
  const $ = _c(8);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M6 20H9M12 20H9M9 20V15" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M17 20V12C17 12 19.5 11 19.5 9C19.5 7.24264 19.5 4.5 19.5 4.5" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M17 8.5V4.5" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M4.49999 11C5.49991 13.1281 8.99999 15 8.99999 15C8.99999 15 12.5001 13.1281 13.5 11C14.5795 8.70257 13.5 4.5 13.5 4.5L4.49999 4.5C4.49999 4.5 3.42047 8.70257 4.49999 11Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props) {
    t5 = <IconWrapper {...props} variant="outline">{t1}{t2}{t3}{t4}</IconWrapper>;
    $[6] = props;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export { Cutlery };